import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "ies-identidad" }
const _hoisted_3 = { class: "ies-meta" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 1,
  class: "info"
}
const _hoisted_10 = { class: "kpis" }
const _hoisted_11 = { class: "kpi-valor" }
const _hoisted_12 = { class: "kpi-detalle" }
const _hoisted_13 = { class: "kpi-valor" }
const _hoisted_14 = { class: "kpi-detalle" }
const _hoisted_15 = { class: "kpi-valor" }
const _hoisted_16 = { class: "kpi-detalle" }
const _hoisted_17 = { class: "kpi-valor" }
const _hoisted_18 = {
  key: 0,
  class: "detalle-kpi"
}
const _hoisted_19 = { class: "dk-cab" }
const _hoisted_20 = { class: "seccion dk-titulo" }
const _hoisted_21 = { class: "dk-conteo" }
const _hoisted_22 = { class: "dk-ayuda" }
const _hoisted_23 = { class: "filtros" }
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "info"
}
const _hoisted_28 = {
  key: 1,
  class: "contenedor-tabla"
}
const _hoisted_29 = { class: "lista-tabla" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "dk-titulo-otorgado"
}
const _hoisted_32 = {
  key: 1,
  class: "dk-nd"
}
const _hoisted_33 = {
  key: 0,
  class: "badge-bandera sem-verde"
}
const _hoisted_34 = {
  key: 1,
  class: "dk-nd"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "semaforo" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "sem-valor" }
const _hoisted_39 = { class: "sem-texto" }
const _hoisted_40 = {
  key: 0,
  class: "sem-chip sem-sin"
}
const _hoisted_41 = { class: "sem-valor" }
const _hoisted_42 = {
  key: 1,
  class: "nota-sin-dato"
}
const _hoisted_43 = { class: "contenedor-tabla" }
const _hoisted_44 = {
  key: 0,
  class: "lista-tabla"
}
const _hoisted_45 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_46 = { class: "contenedor-tabla" }
const _hoisted_47 = { class: "lista-tabla" }
const _hoisted_48 = { class: "col-num total" }
const _hoisted_49 = { class: "col-num total" }
const _hoisted_50 = { class: "modalidades" }
const _hoisted_51 = {
  key: 3,
  class: "mensaje-vacio"
}
const _hoisted_52 = { class: "ficha" }
const _hoisted_53 = { class: "ficha-cab" }
const _hoisted_54 = { class: "ficha-sub" }
const _hoisted_55 = { class: "ficha-datos" }
const _hoisted_56 = { class: "fd-etiqueta" }
const _hoisted_57 = { class: "fd-valor" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 0,
  class: "lista-tabla"
}
const _hoisted_61 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_62 = { class: "ficha-pie" }
const _hoisted_63 = { class: "ficha" }
const _hoisted_64 = { class: "ficha-cab" }
const _hoisted_65 = { class: "ficha-sub" }
const _hoisted_66 = { class: "ficha-datos" }
const _hoisted_67 = { class: "fd-etiqueta" }
const _hoisted_68 = { class: "fd-valor" }
const _hoisted_69 = {
  key: 0,
  class: "lista-tabla"
}
const _hoisted_70 = {
  key: 1,
  class: "dk-nd"
}
const _hoisted_71 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_72 = { class: "ficha-pie" }

import { ref, computed, onMounted } from 'vue'
import { getInstitucionService, type InstitucionSnies } from '@/services/InstitucionSniesService'
import {
  getTableroSniesService,
  listarProgramasSniesService,
  getProgramaSniesService,
  etiquetaTipoActo,
  type TableroSnies,
  type Bandera,
  type ProgramaSnies
} from '@/services/ProgramaSniesService'

type Detalle = 'todos' | 'pregrado' | 'posgrado' | 'vigente' | 'alta_calidad' | 'primer_registro'


export default /*@__PURE__*/_defineComponent({
  __name: 'TableroProgramasView',
  setup(__props) {

/**
 * Tablero de registros SNIES y su vigencia.
 *
 * El semáforo refleja el corte legal: crítico a ≤10 meses del vencimiento, que es
 * el plazo para radicar la renovación.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const tablero = ref<TableroSnies | null>(null)
const institucion = ref<InstitucionSnies | null>(null)
const cargando = ref(false)
const filtroBandera = ref<Bandera | null>(null)

// ── Detalle de un KPI ────────────────────────────────────────────────
const detalle = ref<Detalle | null>(null)
const programas = ref<ProgramaSnies[]>([])
const cargandoLista = ref(false)

/**
 * La lista se pide UNA vez y se reparte aquí.
 *
 * Los criterios (registro vigente, alta calidad, primer registro) llegan ya
 * resueltos por el backend en cada registro; aquí solo se elige qué filas
 * mostrar. Reimplementar los criterios en el cliente haría que el número del
 * KPI y la lista que lo explica pudieran discrepar.
 */
async function abrir(cual: Detalle) {
  detalle.value = detalle.value === cual ? null : cual
  if (detalle.value === null || programas.value.length) return

  cargandoLista.value = true
  try {
    programas.value = await listarProgramasSniesService({ estado: 'Activo' })
  } finally {
    cargandoLista.value = false
  }
}

/** Los que componen el KPI abierto, antes de aplicar los filtros de búsqueda. */
const programasDelKpi = computed<ProgramaSnies[]>(() => {
  const lista = programas.value
  switch (detalle.value) {
    case 'pregrado': return lista.filter(p => p.nivel_academico === 'Pregrado')
    case 'posgrado': return lista.filter(p => p.nivel_academico === 'Posgrado')
    case 'vigente': return lista.filter(p => p.registro_vigente)
    case 'alta_calidad': return lista.filter(p => p.alta_calidad_vigente)
    case 'primer_registro': return lista.filter(p => p.en_primer_registro)
    case 'todos': return lista
    default: return []
  }
})

// ── Filtros de búsqueda ──────────────────────────────────────────────
const busqueda = ref('')
const fCampus = ref('')
const fNivel = ref('')
const fModalidad = ref('')

const hayFiltros = computed(() => !!(busqueda.value || fCampus.value || fNivel.value || fModalidad.value))

function limpiarFiltros() {
  busqueda.value = ''
  fCampus.value = ''
  fNivel.value = ''
  fModalidad.value = ''
}

/** Opciones sacadas de lo que hay cargado, no de una lista fija. */
function opcionesDe(campo: (p: ProgramaSnies) => string | null | undefined): string[] {
  return [...new Set(programas.value.map(campo).filter((v): v is string => !!v))].sort()
}
const opcionesCampus = computed(() => opcionesDe(p => p.campus?.nombre ?? p.municipio))
const opcionesNivel = computed(() => opcionesDe(p => p.nivel_formacion))
const opcionesModalidad = computed(() => opcionesDe(p => p.modalidad))

/** Sin tildes ni mayúsculas: buscar "criminologia" tiene que encontrar "Criminología". */
function normalizar(texto: string): string {
  return texto.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
}

const programasDelDetalle = computed<ProgramaSnies[]>(() => {
  const termino = normalizar(busqueda.value.trim())

  return programasDelKpi.value.filter(p => {
    if (fCampus.value && (p.campus?.nombre ?? p.municipio) !== fCampus.value) return false
    if (fNivel.value && p.nivel_formacion !== fNivel.value) return false
    if (fModalidad.value && p.modalidad !== fModalidad.value) return false
    if (!termino) return true

    return [p.programa?.nombre, p.codigo_snies, p.titulo_otorgado, p.nucleo_basico]
      .some(v => v && normalizar(String(v)).includes(termino))
  })
})

const tituloDetalle = computed(() => ({
  todos: 'Todos los programas activos',
  pregrado: 'Programas de pregrado',
  posgrado: 'Programas de posgrado',
  vigente: 'Con registro calificado vigente',
  alta_calidad: 'Acreditados en alta calidad',
  primer_registro: 'En primer registro'
}[detalle.value ?? 'todos']))

const ayudaDetalle = computed(() => ({
  todos: 'Cada fila es un registro ante el Ministerio: un mismo programa aparece una vez por campus y modalidad.',
  pregrado: 'Nivel académico Pregrado según el maestro del SNIES.',
  posgrado: 'Especializaciones, maestrías y doctorados.',
  vigente: 'Su resolución de registro calificado no ha vencido.',
  alta_calidad: 'Tienen resolución de acreditación vigente.',
  primer_registro: 'Operan bajo su primer registro: nunca han radicado una renovación.'
}[detalle.value ?? 'todos']))

const leyenda: Record<string, string> = {
  roja: 'crítico · menos de 12 meses',
  amarilla: 'advertencia · 12 a 24 meses',
  verde: 'al día · más de 24 meses'
}

/** Niveles presentes en la matriz, en el orden del SNIES. */
const niveles = computed<string[]>(() => {
  const orden = ['Formación técnica profesional', 'Tecnológico', 'Universitario',
    'Especialización tecnológica', 'Especialización universitaria', 'Maestría', 'Doctorado']
  const presentes = new Set<string>()
  for (const fila of Object.values(tablero.value?.matriz_campus_nivel ?? {})) {
    Object.keys(fila).forEach(n => presentes.add(n))
  }
  // Primero los del orden oficial que existan, después cualquier otro.
  return [
    ...orden.filter(n => presentes.has(n)),
    ...[...presentes].filter(n => !orden.includes(n))
  ]
})

const alertasFiltradas = computed(() =>
  (tablero.value?.alertas ?? []).filter(a => !filtroBandera.value || a.bandera === filtroBandera.value)
)

function totalNivel(nivel: string): number {
  let total = 0
  for (const fila of Object.values(tablero.value?.matriz_campus_nivel ?? {})) total += fila[nivel] ?? 0
  return total
}

// ── Ficha de la institución ──────────────────────────────────────────
const fichaIes = ref(false)

const datosInstitucion = computed(() => {
  const i = institucion.value
  if (!i) return []

  return [
    { etiqueta: 'Código SNIES', valor: i.codigo_snies ?? '—' },
    { etiqueta: 'NIT', valor: i.nit ?? '—' },
    { etiqueta: 'Carácter académico', valor: i.caracter_academico ?? '—' },
    { etiqueta: 'Naturaleza jurídica', valor: i.naturaleza_juridica ?? '—' },
    { etiqueta: 'Sector', valor: i.sector ?? '—' },
    { etiqueta: 'Principal o seccional', valor: i.principal_o_seccional ?? '—' },
    { etiqueta: 'Estado', valor: i.estado ?? '—' },
    { etiqueta: 'Domicilio', valor: [i.direccion, i.municipio, i.departamento].filter(Boolean).join(', ') || '—' },
    { etiqueta: 'Teléfono', valor: i.telefono ?? '—' },
    { etiqueta: 'Norma de creación', valor: i.norma_creacion ?? '—' },
    { etiqueta: 'Fecha de la norma', valor: i.fecha_norma ?? '—' },
    { etiqueta: 'Sitio web', valor: i.url ?? '—' }
  ]
})

// ── Ficha del programa ───────────────────────────────────────────────
const fichaAbierta = ref<ProgramaSnies | null>(null)

/**
 * Se pide el detalle al abrir aunque la fila ya venga cargada: el listado no
 * trae todos los campos de caracterización, y mostrar la ficha a medias sería
 * peor que esperar un momento.
 */
async function abrirFicha(p: ProgramaSnies) {
  fichaAbierta.value = p
  const completo = await getProgramaSniesService(p.id_programa_snies)
  if (completo) fichaAbierta.value = completo
}

/** Los datos de caracterización, en el orden en que se leen. */
const datosFicha = computed(() => {
  const f = fichaAbierta.value
  if (!f) return []

  return [
    { etiqueta: 'Código SNIES', valor: f.codigo_snies },
    { etiqueta: 'Código anterior ICFES', valor: f.codigo_anterior_icfes ?? '—' },
    { etiqueta: 'Campus', valor: f.campus?.nombre ?? f.municipio ?? '—' },
    { etiqueta: 'Modalidad', valor: f.modalidad ?? '—' },
    { etiqueta: 'Nivel académico', valor: f.nivel_academico ?? '—' },
    { etiqueta: 'Nivel de formación', valor: f.nivel_formacion ?? '—' },
    { etiqueta: 'Área de conocimiento', valor: f.area_conocimiento ?? '—' },
    { etiqueta: 'Núcleo básico', valor: f.nucleo_basico ?? '—' },
    { etiqueta: 'Créditos', valor: f.creditos ?? '—' },
    { etiqueta: 'Duración', valor: f.periodos_duracion ? `${f.periodos_duracion} periodos` : '—' },
    { etiqueta: 'Periodicidad', valor: f.periodicidad ?? '—' },
    { etiqueta: 'Ubicación', valor: [f.municipio, f.departamento].filter(Boolean).join(', ') || '—' },
    { etiqueta: 'En el SNIES desde', valor: f.fecha_registro_snies ?? '—' },
    {
      etiqueta: 'Años de funcionamiento',
      valor: f.anios_funcionamiento !== null && f.anios_funcionamiento !== undefined
        ? `${f.anios_funcionamiento} años` : '—'
    },
    { etiqueta: 'Estado', valor: f.estado ?? '—' },
    {
      etiqueta: 'Costo de matrícula',
      valor: f.costo_matricula ? `$ ${f.costo_matricula.toLocaleString('es-CO')}` : '—'
    }
  ]
})

/** Un vencido no es lo mismo que uno por vencer: se dice con todas las letras. */
function textoUrgencia(meses: number | null): string {
  if (meses === null) return 'sin fecha'
  if (meses < 0) return `vencido hace ${Math.abs(meses)} meses`
  return `vence en ${meses} meses`
}

onMounted(async () => {
  cargando.value = true
  try {
    tablero.value = await getTableroSniesService()
    institucion.value = await getInstitucionService()
  } finally {
    cargando.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_drag_scroll = _resolveDirective("drag-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "header-flex" }, [
      _createElementVNode("h1", null, "Tablero de Programas")
    ], -1)),
    _cache[50] || (_cache[50] = _createElementVNode("p", { class: "subtitulo" }, " Estado de la oferta académica frente al Sistema de Aseguramiento de la Calidad. Los vencimientos y las alertas se calculan de las resoluciones; no se capturan a mano. ", -1)),
    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (institucion.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "ies",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (fichaIes.value = true))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(institucion.value.nombre), 1),
            _createElementVNode("p", _hoisted_3, [
              (institucion.value.codigo_snies)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "SNIES " + _toDisplayString(institucion.value.codigo_snies), 1))
                : _createCommentVNode("", true),
              (institucion.value.caracter_academico)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "· " + _toDisplayString(institucion.value.caracter_academico), 1))
                : _createCommentVNode("", true),
              (institucion.value.sector)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "· " + _toDisplayString(institucion.value.sector), 1))
                : _createCommentVNode("", true),
              (institucion.value.municipio)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "· " + _toDisplayString(institucion.value.municipio) + ", " + _toDisplayString(institucion.value.departamento), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["ies-acreditacion", institucion.value.acreditacion_vigente ? 'ok' : 'no']),
            title: institucion.value.acreditacion_vigente
          ? 'Acreditación institucional vigente'
          : 'La institución no está acreditada; es distinto de que lo estén sus programas'
          }, _toDisplayString(institucion.value.acreditacion_vigente
          ? 'Acreditada en alta calidad'
          : 'Sin acreditación institucional'), 11, _hoisted_8),
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ies-abrir" }, "ver ficha ›", -1))
        ]))
      : _createCommentVNode("", true),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Cargando tablero…"))
      : (tablero.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: _normalizeClass(["kpi", { activo: detalle.value === 'todos' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (abrir('todos')))
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(tablero.value.kpis.total_programas), 1),
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "kpi-nombre" }, "Programas activos", -1)),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "kpi-sub",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (abrir('pregrado')), ["stop"]))
                  }, _toDisplayString(tablero.value.kpis.pregrado) + " pregrado", 1),
                  _cache[17] || (_cache[17] = _createTextVNode(" · ")),
                  _createElementVNode("span", {
                    class: "kpi-sub",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (abrir('posgrado')), ["stop"]))
                  }, _toDisplayString(tablero.value.kpis.posgrado) + " posgrado", 1)
                ])
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["kpi", { activo: detalle.value === 'vigente' }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (abrir('vigente')))
              }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(tablero.value.kpis.con_registro_vigente), 1),
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "kpi-nombre" }, "Con registro vigente", -1)),
                _createElementVNode("span", _hoisted_14, "de " + _toDisplayString(tablero.value.kpis.total_programas), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["kpi kpi-destacado", { activo: detalle.value === 'alta_calidad' }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (abrir('alta_calidad')))
              }, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(tablero.value.kpis.con_alta_calidad), 1),
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "kpi-nombre" }, "Acreditados en alta calidad", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(tablero.value.kpis.pct_alta_calidad) + "% de la oferta", 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["kpi", { activo: detalle.value === 'primer_registro' }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (abrir('primer_registro')))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(tablero.value.kpis.en_primer_registro), 1),
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "kpi-nombre" }, "En primer registro", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "kpi-detalle" }, "nunca han renovado", -1))
              ], 2)
            ]),
            (detalle.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h2", _hoisted_20, _toDisplayString(tituloDetalle.value), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(programasDelDetalle.value.length) + " registro" + _toDisplayString(programasDelDetalle.value.length === 1 ? '' : 's'), 1),
                    _createElementVNode("button", {
                      class: "dk-cerrar",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (detalle.value = null))
                    }, "✕")
                  ]),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(ayudaDetalle.value), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((busqueda).value = $event)),
                      class: "filtro-input filtro-busqueda",
                      placeholder: "Buscar por programa, código SNIES o título…"
                    }, null, 512), [
                      [_vModelText, busqueda.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fCampus).value = $event)),
                      class: "filtro-input"
                    }, [
                      _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, "Todos los campus", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesCampus.value, (c) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: c,
                          value: c
                        }, _toDisplayString(c), 9, _hoisted_24))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, fCampus.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fNivel).value = $event)),
                      class: "filtro-input"
                    }, [
                      _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "Todos los niveles", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesNivel.value, (n) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: n,
                          value: n
                        }, _toDisplayString(n), 9, _hoisted_25))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, fNivel.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((fModalidad).value = $event)),
                      class: "filtro-input"
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "Toda modalidad", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesModalidad.value, (m) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: m,
                          value: m
                        }, _toDisplayString(m), 9, _hoisted_26))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, fModalidad.value]
                    ]),
                    (hayFiltros.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "filtro-limpiar",
                          onClick: limpiarFiltros
                        }, "Limpiar"))
                      : _createCommentVNode("", true)
                  ]),
                  (cargandoLista.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Cargando programas…"))
                    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("table", _hoisted_29, [
                          _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "SNIES"),
                              _createElementVNode("th", null, "PROGRAMA"),
                              _createElementVNode("th", null, "CAMPUS"),
                              _createElementVNode("th", null, "MODALIDAD"),
                              _createElementVNode("th", null, "NIVEL"),
                              _createElementVNode("th", null, "REGISTRO"),
                              _createElementVNode("th", null, "ALTA CALIDAD")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programasDelDetalle.value, (p) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: p.id_programa_snies
                              }, [
                                _createElementVNode("td", null, _toDisplayString(p.codigo_snies), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    class: "link-programa",
                                    onClick: ($event: any) => (abrirFicha(p))
                                  }, _toDisplayString(p.programa?.nombre ?? '—'), 9, _hoisted_30),
                                  (p.titulo_otorgado)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(p.titulo_otorgado), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(p.campus?.nombre ?? p.municipio ?? '—'), 1),
                                _createElementVNode("td", null, _toDisplayString(p.modalidad ?? '—'), 1),
                                _createElementVNode("td", null, _toDisplayString(p.nivel_formacion ?? '—'), 1),
                                _createElementVNode("td", null, [
                                  (p.vence_registro)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(['badge-bandera', p.bandera ? `sem-${p.bandera}` : ''])
                                      }, " vence " + _toDisplayString(p.vence_registro), 3))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "sin resolución"))
                                ]),
                                _createElementVNode("td", null, [
                                  (p.alta_calidad_vigente)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, " acreditado · vence " + _toDisplayString(p.vence_alta_calidad), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_34, "—"))
                                ])
                              ]))
                            }), 128)),
                            (!programasDelDetalle.value.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_35, _cache[26] || (_cache[26] = [
                                  _createElementVNode("td", {
                                    colspan: "7",
                                    class: "mensaje-vacio"
                                  }, "No hay programas en este grupo.", -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])), [
                        [_directive_drag_scroll]
                      ])
                ]))
              : _createCommentVNode("", true),
            _cache[34] || (_cache[34] = _createElementVNode("h2", { class: "seccion" }, "Alertas tempranas", -1)),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['roja', 'amarilla', 'verde'], (b) => {
                return _createElementVNode("button", {
                  key: b,
                  class: _normalizeClass(['sem-chip', `sem-${b}`, { activo: filtroBandera.value === b }]),
                  onClick: ($event: any) => (filtroBandera.value = filtroBandera.value === b ? null : (b as Bandera))
                }, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(tablero.value.banderas[b as Bandera]), 1),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(leyenda[b]), 1)
                ], 10, _hoisted_37)
              }), 64)),
              (tablero.value.banderas.sin_dato)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(tablero.value.banderas.sin_dato), 1),
                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sem-texto" }, "sin fecha para calcular", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (tablero.value.banderas.sin_dato)
              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _cache[29] || (_cache[29] = [
                  _createTextVNode(" Los que no tienen fecha de ejecutoria o vigencia "),
                  _createElementVNode("strong", null, "no se cuentan como al día", -1),
                  _createTextVNode(": no se puede saber cuándo vencen. ")
                ])))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_43, [
              (alertasFiltradas.value.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_44, [
                    _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "SNIES"),
                        _createElementVNode("th", null, "PROGRAMA"),
                        _createElementVNode("th", null, "CAMPUS"),
                        _createElementVNode("th", null, "MODALIDAD"),
                        _createElementVNode("th", null, "VENCE"),
                        _createElementVNode("th", null, "ESTADO")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertasFiltradas.value, (a) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: a.id_programa_snies
                        }, [
                          _createElementVNode("td", null, _toDisplayString(a.codigo_snies), 1),
                          _createElementVNode("td", null, _toDisplayString(a.programa ?? '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(a.campus ?? '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(a.modalidad ?? '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(a.vence ?? '—'), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['badge-bandera', `sem-${a.bandera}`])
                            }, _toDisplayString(textoUrgencia(a.meses_para_vencer)), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(filtroBandera.value ? 'No hay programas en ese estado.' : 'No hay alertas activas.'), 1))
            ])), [
              [_directive_drag_scroll]
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "seccion" }, "Campus por nivel de formación", -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("table", _hoisted_47, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[31] || (_cache[31] = _createElementVNode("th", null, "CAMPUS", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(niveles.value, (n) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: n,
                        class: "col-num"
                      }, _toDisplayString(n), 1))
                    }), 128)),
                    _cache[32] || (_cache[32] = _createElementVNode("th", { class: "col-num" }, "TOTAL", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablero.value.matriz_campus_nivel, (niv, campus) => {
                    return (_openBlock(), _createElementBlock("tr", { key: campus }, [
                      _createElementVNode("td", null, _toDisplayString(campus), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(niveles.value, (n) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: n,
                          class: "col-num"
                        }, _toDisplayString(niv[n] ?? '·'), 1))
                      }), 128)),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(tablero.value.por_campus[campus] ?? 0), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", null, [
                    _cache[33] || (_cache[33] = _createElementVNode("td", null, "TOTAL", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(niveles.value, (n) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: n,
                        class: "col-num total"
                      }, _toDisplayString(totalNivel(n)), 1))
                    }), 128)),
                    _createElementVNode("td", _hoisted_49, _toDisplayString(tablero.value.kpis.total_programas), 1)
                  ])
                ])
              ])
            ])), [
              [_directive_drag_scroll]
            ]),
            _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "seccion" }, "Por modalidad", -1)),
            _createElementVNode("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablero.value.por_modalidad, (n, m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m,
                  class: "mod-chip"
                }, [
                  _createElementVNode("strong", null, _toDisplayString(n), 1),
                  _createTextVNode(" " + _toDisplayString(m), 1)
                ]))
              }), 128))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_51, "No se pudo cargar el tablero.")),
    (fichaIes.value && institucion.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "ficha-overlay",
          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (fichaIes.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, _toDisplayString(institucion.value.nombre), 1),
                _createElementVNode("p", _hoisted_54, _toDisplayString(institucion.value.caracter_academico ?? 'Institución de educación superior'), 1)
              ]),
              _createElementVNode("button", {
                class: "ficha-cerrar",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (fichaIes.value = false))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_55, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datosInstitucion.value, (d) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: d.etiqueta,
                  class: "fd"
                }, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(d.etiqueta), 1),
                  _createElementVNode("span", _hoisted_57, _toDisplayString(d.valor), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["ies-acred-detalle", institucion.value.acreditacion_vigente ? 'ok' : 'no'])
            }, [
              (institucion.value.acreditacion_vigente)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Acreditada en alta calidad", -1)),
                    (institucion.value.resolucion_acreditacion)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, " · resolución " + _toDisplayString(institucion.value.resolucion_acreditacion), 1))
                      : _createCommentVNode("", true),
                    (institucion.value.vence_acreditacion_calculado)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, " · vence " + _toDisplayString(institucion.value.vence_acreditacion_calculado), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Sin acreditación institucional.", -1)),
                    _createTextVNode(" No es lo mismo que los programas acreditados: " + _toDisplayString(tablero.value?.kpis.con_alta_calidad ?? 0) + " de " + _toDisplayString(tablero.value?.kpis.total_programas ?? 0) + " programas sí la tienen. ", 1)
                  ], 64))
            ], 2),
            _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "ficha-seccion" }, "Directivos", -1)),
            (institucion.value.directivos?.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_60, [
                  _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "CARGO"),
                      _createElementVNode("th", null, "NOMBRE"),
                      _createElementVNode("th", null, "DEPENDENCIA"),
                      _createElementVNode("th", null, "ACTO"),
                      _createElementVNode("th", null, "DESDE"),
                      _createElementVNode("th", null, "HASTA")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(institucion.value.directivos, (d) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: d.id_directivo,
                        class: _normalizeClass({ saliente: !d.vigente })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(d.cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(d.nombre_completo), 1),
                        _createElementVNode("td", null, _toDisplayString((d as any).area?.nombre ?? '—'), 1),
                        _createElementVNode("td", null, _toDisplayString(d.acto_nombramiento ?? '—'), 1),
                        _createElementVNode("td", null, _toDisplayString(d.fecha_desde ?? '—'), 1),
                        _createElementVNode("td", null, _toDisplayString(d.fecha_hasta ?? 'en el cargo'), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_61, "Sin directivos registrados.")),
            _createElementVNode("p", _hoisted_62, [
              _cache[41] || (_cache[41] = _createTextVNode(" Para editar estos datos ve a ")),
              _createVNode(_component_router_link, { to: { name: 'GestionAreas' } }, {
                default: _withCtx(() => _cache[40] || (_cache[40] = [
                  _createTextVNode("Estructura Organizacional")
                ])),
                _: 1,
                __: [40]
              }),
              _cache[42] || (_cache[42] = _createTextVNode(" y selecciona la institución. "))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (fichaAbierta.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "ficha-overlay",
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (fichaAbierta.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, _toDisplayString(fichaAbierta.value.programa?.nombre ?? 'Programa'), 1),
                _createElementVNode("p", _hoisted_65, _toDisplayString(fichaAbierta.value.titulo_otorgado ?? 'Sin título registrado'), 1)
              ]),
              _createElementVNode("button", {
                class: "ficha-cerrar",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (fichaAbierta.value = null))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_66, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datosFicha.value, (d) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: d.etiqueta,
                  class: "fd"
                }, [
                  _createElementVNode("span", _hoisted_67, _toDisplayString(d.etiqueta), 1),
                  _createElementVNode("span", _hoisted_68, _toDisplayString(d.valor), 1)
                ]))
              }), 128))
            ]),
            _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "ficha-seccion" }, "Actos administrativos", -1)),
            (fichaAbierta.value.resoluciones?.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_69, [
                  _cache[44] || (_cache[44] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "ACTO"),
                      _createElementVNode("th", null, "NÚMERO"),
                      _createElementVNode("th", null, "EJECUTORIA"),
                      _createElementVNode("th", null, "VIGENCIA"),
                      _createElementVNode("th", null, "VENCE")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fichaAbierta.value.resoluciones, (r) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: r.id_resolucion
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_unref(etiquetaTipoActo)(r.tipo_acto)), 1),
                        _createElementVNode("td", null, _toDisplayString(r.numero ?? '—'), 1),
                        _createElementVNode("td", null, _toDisplayString(r.fecha_ejecutoria ?? '—'), 1),
                        _createElementVNode("td", null, _toDisplayString(r.vigencia_anios ? r.vigencia_anios + ' años' : '—'), 1),
                        _createElementVNode("td", null, [
                          (r.fecha_vencimiento)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(['badge-bandera', r.bandera ? `sem-${r.bandera}` : ''])
                              }, _toDisplayString(r.fecha_vencimiento), 3))
                            : (_openBlock(), _createElementBlock("span", _hoisted_70, "no calculable"))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_71, "Sin resoluciones registradas.")),
            _createElementVNode("p", _hoisted_72, [
              _cache[46] || (_cache[46] = _createTextVNode(" Para editar este registro o agregar resoluciones, ve a ")),
              _createVNode(_component_router_link, { to: { name: 'GestionAreas' } }, {
                default: _withCtx(() => _cache[45] || (_cache[45] = [
                  _createTextVNode("Estructura Organizacional")
                ])),
                _: 1,
                __: [45]
              }),
              _cache[47] || (_cache[47] = _createTextVNode(" y selecciona el programa. "))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})